<template>
  <form
    autocomplete="off"
    class="gap-0 gap-y-4 "
    @submit.prevent="submitForm"
  >
    <div class="col-span-12 mx-auto text-center w-full">
      <h2 class="">
        {{ category ? 'Edit' : 'Add' }} Category
      </h2>

      <TextInput
        v-model="formData.name"
        label="Name"
        class="mb-8"
        :validation-error="errors && 'name' in errors && errors.name[0]"
      />

      <div
        class="flex items-center gap-2 mb-6 cursor-pointer w-fit"
        @click="formData.protected = !formData.protected"
      >
        <input
          v-model="formData.protected"
          type="checkbox"
          :checked="formData.protected"
          class="w-5 h-5 rounded"
        >
        <span class="">Protected</span>
      </div>

      <div class="flex gap-3">
        <AppButton
          :disabled="processing"
          class="btn btn-outline btn-secondary py-2.5 w-full"
          @click="$emit('close')"
        >
          Cancel
        </AppButton>

        <AppButton
          :processing="processing"
          class="btn btn-solid btn-secondary py-2.5 w-full"
        >
          {{ processing ? 'Confirming' : 'Confirm' }}
        </AppButton>
      </div>
    </div>
  </form>
</template>

<script setup>
import { reactive } from 'vue';

import { AppButton } from '@/components/app';
import { TextInput } from '@/components/forms/inputs';

const emit = defineEmits(['close', 'confirm']);

const props = defineProps({
  category: {
    type: Object,
    default: () => {},
  },
  errors: {
    type: Object,
    default: () => {},
  },
  processing: Boolean,
});

const formData = reactive({
  name: props.category?.name || null,
  protected: props.category?.protected || false,
});

const submitForm = () => {
  if (!props.processing) {
    emit('confirm', formData);
  }
};
</script>
